import React from "react";
import useReveal from "../hooks/useReveal";

export default function IntroBand() {
  const ref = useReveal();
  return (
    <section className="mt-8 bg-navy">
      <div ref={ref} className="reveal mx-auto max-w-4xl px-4 py-14 text-center lg:px-8">
        <p className="mb-3 text-xs font-bold uppercase tracking-[0.25em] text-brand">
          Cyberfit Gym Equipment
        </p>
        <h1 className="font-heading text-3xl font-extrabold italic text-white md:text-4xl">
          Australia&rsquo;s Premium Gym &amp; Exercise Equipment
        </h1>
        <p className="mx-auto mt-5 max-w-3xl text-sm leading-relaxed text-white/70 md:text-base">
          Your one-stop destination for top-quality gym gear in Australia. Whether you&rsquo;re
          outfitting a home gym or a commercial fitness centre, our extensive range of exercise
          equipment is built for performance, durability and value. Since 2004, Australians have
          relied on Cyberfit for quality gym equipment and fitness solutions.
        </p>
      </div>
    </section>
  );
}
